import { createFormActions, createInput, createInputFile, createSelect, createTextArea } from ":ui/form";
import { person_name } from ":shared/helpers/validations/user";

export function updateProfileInputs() {
  const Image = createInputFile(null, {
    required: false,
  });
  const FirstName = createInput("" as string, {
    required: true,
    validators: (value: string) => {
      const err = !!value && person_name.validate(value);
      return err?.length > 0 ? { [err]: true } : undefined;
    },
  });

  const LastName = createInput("" as string, {
    required: true,
    validators: (value: string) => {
      const err = !!value && person_name.validate(value);
      return err?.length > 0 ? { [err]: true } : undefined;
    },
  });

  const Email = createInput("", {
    required: true,
  });

  const Track = createSelect("", {
    required: false,
  });

  const Major = createInput("", {
    required: false,
  });

  const Portfolio = createInput("", {
    required: false,
  });

  const Bio = createTextArea("", {
    required: false,
  });

  const Actions = createFormActions(
    {
      Image,
      FirstName,
      LastName,
      Email,
      Track,
      Major,
      Portfolio,
      Bio,
    },
    {
      defaultCase: "snake",
      onUpdateKeyNotFound: "hide",
    }
  );

  return {
    Actions,
    Image,
    FirstName,
    LastName,
    Email,
    Track,
    Major,
    Portfolio,
    Bio,
  };
}
